import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
const CompanyContainer = styled.div``
const EmptyContainer = styled.div``
import { getCookie } from 'helper/cookie'
import {
  getDataHoliday,
  getTreeHoliday,
  getDataHolidayDetail,
  exportHolidayDetail,
  getDataHolidayV2,
  getTreeHolidayV2,
  getCompanyData,
} from 'api/Admin/holiday'
import { Button, Table, Input, Space, Pagination, Row, Col } from 'antd'
import moment from 'moment'
import Tree from '../Tree/Company/TreeHoliday'
import Importfile from 'common/Management/Importfile'
import {
  PlusOutlined,
  SearchOutlined,
  RedoOutlined,
  DeleteOutlined,
  DownloadOutlined,
} from '@ant-design/icons'

import iconEmpty from 'icons/createproject/supportneed.svg'
import DrawerHoliday from './HolidayComponent/DrawerHoliday'
import ExportModalHoliday from '../components/HolidayComponent/Modal/ExportHolidayDetail'
import AddEditModalHoliday from '../components/HolidayComponent/Modal/AddEditHolidayDetail'
import DeleteHoliday from 'common/Management/deletenocheck'
//checkrole
import { CounterContext } from 'redux/Golbalvalues'
import lang from 'lang/en'
import { TreeSelect, Tag, Form, Checkbox } from 'antd'
// เพิ่มบรรทัดนี้ที่ส่วน import
import FilterSearchTree from './FilterSearchTree'

const initalState = {
  data: [],
  isLoading: true,
  pagination: {
    pageSize: 10, //จำนวนข้อมูลในหน้านั้น
    total: 0, //ข้อมูลทั้งหมด
    current: 1,
    // showSizeChanger: true,
    showQuickJumper: 1,
    // showTotal: (total, range) => showToalPagination(total, range),
  },
}
const showToalPagination = (total, range) => {
  return <p className="small-show-total">{`${range[0]}-${range[1]} of ${total}`}</p>
}

const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
`

const Company = (props) => {
  const { infoUser, openDefaultTree, today, openDefaultTree3 } = props
  const language = getCookie('lang')
  const word = lang[language]
  const token = getCookie('access_token_admin')
  const [isLoading, setIsLoading] = useState(initalState.isLoading)
  //new update feature state
  const [visibleexportmodal, setVisibleExportmodal] = useState(false)
  //suboperation drawer
  const [parent_ID, setParent_ID] = useState(1)

  //datacompany
  const [dataCompany, setDataCompany] = useState(initalState.data)

  //dataHolidayDetail
  const [dataHolidayDetail, setDataHolidayDetail] = useState(initalState.data)
  const [dataModalAddEditHoliday, setDataModalAddEditHoliday] = useState(false)
  const [selectedRowKeys, setSelectRowKeys] = useState([])
  const [company_id, setCompany_id] = useState()
  const [operation_id, setOperation_id] = useState()
  const [suboperation_id, setSubOperation_id] = useState()
  const [visibleDelete, setVisibleDelete] = useState()
  const [dataDeleteHoliday, setDataDeleteHoliday] = useState()

  //datatree
  const [treeCompany, setTreeCompany] = useState(initalState.data)
  // console.log(treeCompany)
  const [level, setLevel] = useState('initital')
  const [level_ID, setLevel_ID] = useState(0)

  const [companyID, setCompanyID] = useState(0)

  const [dataExpanse, setDataExpanse] = useState(initalState.data)
  const [dataSelected, setDataSelected] = useState(initalState.data)
  // console.log(companyID, company_id)
  //table
  const [checkChangeTable, setCheckChangeTable] = useState(0)
  // console.log(checkChangeTable)
  //search
  const [searchText, setSearchText] = useState('')
  const [searchedColumn, setSearchedColumn] = useState('')

  //drawer
  const [visible, setVisible] = useState(false)
  const [dataAddEditHoliday, setDataAddEditHoliday] = useState('')

  //pagination
  const [pagination, setPagination] = useState(initalState.pagination)

  //modal
  const [visibleModalAddEditHoliday, setVisibleModalAddEditHoliday] = useState(false)

  // import file
  const [visibleModal, setVisibleModal] = useState(false)

  //checkrole
  const { adminPermission } = useContext(CounterContext)

  const [disablePage, setDisablePage] = useState(false)

  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  const [resultscompany, setResultscompany] = useState([])
  const [filteredCompanies, setFilteredCompanies] = useState([])
  const [filteredTreeCompany, setFilteredTreeCompany] = useState([])
  const [selectedCompany, setSelectedCompany] = useState(null)

  const roleUser = getCookie('roleUser')
  useEffect(() => {
    if (roleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      adminPermission.map((item) => {
        if (item.menu_id == 13) {
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      })
    }
  }, [adminPermission])

  // useEffect for filteredCompanies
  useEffect(() => {
    if (filteredCompanies.length > 0) {
      const filteredTree = treeCompany.filter((item) =>
        filteredCompanies.includes(item.id),
      )
      setFilteredTreeCompany(filteredTree)
      setSelectedCompany(filteredTree[0]?.id)
    } else {
      setFilteredTreeCompany(treeCompany)
      setSelectedCompany(treeCompany[0]?.id)
    }
  }, [filteredCompanies, treeCompany])

  // get first company ID from tree
  useEffect(() => {
    fetchListHolidayINcompany()
  }, [selectedCompany])

  // get company by role for filter box
  const getCompanyDataByRole = async () => {
    await getCompanyData({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          await setResultscompany([])

          return true
        }
        if (status === 200) {
          await setResultscompany(data.result)
        } else {
          await setResultscompany([])
          return true
        }
      })
      .catch((error) => {
        console.error(error)
      })
  }

  //tree
  const getResultTreeCompany = async () => {
    // console.log('come Fetch result tree')
    await getTreeHolidayV2({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setTreeCompany([])

          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setTreeCompany(data.result)
          if (level == 'initital') {
            //await fetchListHolidayINcompany(data.result[0].id)
            setSelectedCompany(data.result[0].id)
          }

          setIsLoading(false)
        } else {
          setTreeCompany([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setTreeCompany([])
        setIsLoading(false)
        console.error(error)
      })
  }
  const fetchListHolidayINcompany = async (parentID) => {
    await getDataHoliday({
      token: token,
      parent_id: selectedCompany,
      level_id: '',
      id: '',
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataCompany([])

          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataCompany(data)
          if (data.length <= 10) {
            setPagination(false)
          } else {
            setPagination(initalState.pagination)
          }

          setIsLoading(false)
        } else {
          setDataCompany([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataCompany([])
        setIsLoading(false)
        console.error(error)
      })
  }

  //data company
  const getResultDataCompany = async () => {
    let level_IDin = level_ID
    let companyIDin = companyID
    if (level == 1) {
      level_IDin = ''
      companyIDin = ''
    } else if (level == 2) {
      companyIDin = ''
    }

    await getDataHoliday({
      token: token,
      parent_id: parent_ID,
      level_id: level_IDin,
      id: companyIDin,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataCompany([])

          setIsLoading(false)
          return true
        }
        if (status === 200) {
          setDataCompany(data)
          if (data.length <= 10) {
            setPagination(false)
          } else {
            setPagination(initalState.pagination)
          }

          setIsLoading(false)
        } else {
          setDataCompany([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataCompany([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const getResultDataHolidayDetail = async () => {
    await getDataHolidayDetail({
      token: token,
      holiday_id: parent_ID,
    })
      .then(async (response) => {
        const { status, data, error } = response

        if (error) {
          setDataHolidayDetail([])

          setIsLoading(false)
          return true
        }
        if (status === 200) {
          // console.log('comeget current newdata', data)
          setDataHolidayDetail(data)
          if (data.length <= 10) {
            setPagination(false)
          } else {
            setPagination(initalState.pagination)
          }

          setIsLoading(false)
        } else {
          setDataHolidayDetail([])

          setIsLoading(false)
          return true
        }
      })
      .catch((error) => {
        setDataHolidayDetail([])
        setIsLoading(false)
        console.error(error)
      })
  }

  const [path, setPath] = useState()

  const onClickExport = () => {
    const dataArray = {}
    try {
      exportHolidayDetail({
        params: dataArray,
        token: token,
        holiday_id: parent_ID,
      }).then((res) => {
        if (res.status === 200) {
          setPath(res.data.path)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }
  useEffect(() => {
    if (token) {
      getResultDataCompany()
      getResultTreeCompany()
      getCompanyDataByRole()
    }
  }, [token])

  useEffect(() => {
    if (level == 4) {
      if (checkChangeTable == 9998) {
        getResultDataHolidayDetail()
        setCheckChangeTable(0)
      }
      setSelectRowKeys([])
      getResultDataHolidayDetail()
      onClickExport()
    } else {
      if (checkChangeTable == 9998) {
        getResultDataCompany()
        setCheckChangeTable(0)
      }
      if (treeCompany.length !== 0) {
        // console.log('go fetch')
        getResultTreeCompany()
      }

      getResultDataCompany()
    }
  }, [checkChangeTable])

  const getColumnSearchProps = (dataIndex, state) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => {
      if (state == 'delete') {
        handleReset()
      }
      return (
        <div style={{ padding: 8 }}>
          <Input
            placeholder={`Search ${dataIndex}`}
            value={selectedKeys[0]}
            onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
            style={{ marginBottom: 8, display: 'block' }}
          />
          <Space>
            <Button
              type="primary"
              className="mini-search-btn-admin"
              onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            >
              <SearchOutlined className="icon" />
              {word['Search']}
            </Button>
            <Button
              type="primary"
              className="mini-search-btn-admin-reset"
              onClick={() => handleReset(clearFilters)}
            >
              {word['Reset']}
            </Button>
          </Space>
        </div>
      )
    },
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',

    render: (text) => (searchedColumn === dataIndex ? text : text),
  })

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm()
    setSearchText(selectedKeys[0])
    setSearchedColumn(dataIndex)
  }

  const handleReset = (clearFilters) => {
    clearFilters()
    setSearchText('')
  }

  const dataSource = dataCompany.map((item) => {
    if (item.name_en == undefined) {
      item.name_en = ''
    }
    return {
      key: item.id,
      Company: item.company_code,
      Operation: item.operation_code,
      SubOperation: item.suboperation_code,
      LocalName: item.name,
      EnglishName: item.name_en,
      dataAll: item,
    }
  })

  const columns = [
    {
      title: 'Business',
      dataIndex: 'Company',
      ellipsis: true,
      width: 130,
    },
    {
      title: word['Operation'],
      dataIndex: 'Operation',
      ellipsis: true,
      width: 130,
      sorter: (a, b) => a.Operation.localeCompare(b.Operation),
      ...getColumnSearchProps('Operation'),
    },
    {
      title: word['Sub_operation'],
      dataIndex: 'SubOperation',
      ellipsis: true,
      sorter: (a, b) => a.SubOperation.localeCompare(b.SubOperation),
      ...getColumnSearchProps('SubOperation'),
    },

    {
      title: word['Local_name'],
      dataIndex: 'LocalName',
      sorter: (a, b) => a.LocalName.localeCompare(b.LocalName),
      ...getColumnSearchProps('LocalName'),
      ellipsis: true,
    },
    {
      title: word['English_name'],
      dataIndex: 'EnglishName',
      sorter: (a, b) => a.EnglishName.localeCompare(b.EnglishName),
      ...getColumnSearchProps('EnglishName'),
      ellipsis: true,
    },
  ]

  const onSelectChange = (selectedRowKeys) => {
    setSelectRowKeys(selectedRowKeys)
  }

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  }

  const dataSourceHolidayDetaiil = dataHolidayDetail.map((item) => {
    if (item.name_en == undefined) {
      item.name_en = ''
    }

    let aaaa = item.holiday_date.split('-')
    let bbbb = []
    bbbb.push(aaaa[2])
    bbbb.push(aaaa[1])
    bbbb.push(aaaa[0])
    let cccc = bbbb.join('/')

    return {
      Holidaydate: item.holiday_date,
      HolidaydateSearch: cccc,
      LocalName: item.name,
      EnglishName: item.name_en,
      Remark: item.remark,
      holidayid: item.holiday_id,
      dataAll: item,
      key: item.id,
    }
  })

  const columnsHolidayDetaiil = [
    {
      title: word['Holiday_date'],
      dataIndex: 'Holidaydate',
      ellipsis: true,
      width: 250,
      ...getColumnSearchProps('HolidaydateSearch'),
      sorter: (a, b) => a.Holidaydate.localeCompare(b.Holidaydate),
      render: (text) => {
        return moment(text).format('DD/MM/YYYY')
      },
    },
    {
      title: word['Local_name'],
      dataIndex: 'LocalName',
      ellipsis: true,
      width: 250,
      sorter: (a, b) => a.LocalName.localeCompare(b.LocalName),
      ...getColumnSearchProps('LocalName'),
    },
    {
      title: word['English_name'],
      dataIndex: 'EnglishName',
      ellipsis: true,
      width: 250,
      sorter: (a, b) => a.EnglishName.localeCompare(b.EnglishName),
      ...getColumnSearchProps('EnglishName'),
    },

    {
      title: word['Remark'],
      dataIndex: 'Remark',
      sorter: (a, b) => a.Remark.localeCompare(b.Remark),
      ...getColumnSearchProps('Remark'),
      ellipsis: true,
    },
  ]

  const eventAdd = () => {
    setVisible(true)
    const dataArray = {
      state: 'add',
      parent_ID: parent_ID,
      level_ID: level_ID,
      companyID: companyID,
      dataExpanse: dataExpanse,
      dataSelected: dataSelected,
      level: level,
    }
    setDataAddEditHoliday(dataArray)
  }
  const eventEdit = (e) => {
    setVisible(true)

    const dataArray = {
      state: 'edit',
      parent_ID: parent_ID,
      level_ID: level_ID,
      companyID: companyID,
      dataEdit: e.dataAll,
      dataExpanse: dataExpanse,
      dataSelected: dataSelected,
      level: level,
    }
    setDataAddEditHoliday(dataArray)
  }

  const onClickRow = (e) => {
    eventEdit(e)
  }

  function onChangeTable(pagination2, filters, sorter, extra) {
    if (pagination != false) {
      setPagination((prevState) => {
        return {
          ...prevState,
          pageSize: pagination2.pageSize,
          current: pagination2.current,
        }
      })
      setSelectRowKeys([])
    }
  }

  // let locale = {
  //   emptyText: (
  //     <div className="empty-table-custom" style={{ marginBottom: 32 }}>
  //       <img className="icon" src={iconEmpty}></img>
  //       <h2>{word['Please_add_Holiday_in_your_project_optional']}</h2>

  //       <Button
  //         type="primary"
  //         onClick={() => onClickModalAddEditHolidayDetail('add')}
  //         className="btn_Secondary2"
  //       >
  //         <PlusOutlined className="Icon-color" />
  //         {word['Add_Holiday_Detail']}
  //       </Button>
  //     </div>
  //   ),
  // }

  const onClickModalAddEditHolidayDetail = (state, item) => {
    if (state == 'add') {
      setVisibleModalAddEditHoliday(true)
      const dataArray = {
        state: 'add',
        idHoliday: parent_ID,
      }
      setDataModalAddEditHoliday(dataArray)
    } else {
      setVisibleModalAddEditHoliday(true)

      const dataArray = {
        state: 'edit',
        idHoliday: parent_ID,
        dataEdit: item.dataAll,
      }
      setDataModalAddEditHoliday(dataArray)
    }
  }

  const onClickRowDetail = (item) => {
    onClickModalAddEditHolidayDetail('edit', item)
  }

  const checkShowTable = (levelin) => {
    if (level == 4) {
      return (
        <Table
          className="table-management-custom"
          rowSelection={rowSelection}
          key={checkChangeTable + 'HolidayDetail'}
          style={{ marginTop: 32 }}
          onRow={(record) => {
            return {
              onClick: () => onClickRowDetail(record),
            }
          }}
          dataSource={dataSourceHolidayDetaiil}
          columns={columnsHolidayDetaiil}
          onChange={onChangeTable}
          pagination={pagination}
          showSorterTooltip={false}
        />
      )
    } else {
      return (
        <Table
          key={checkChangeTable + 'Company'}
          onRow={(record) => {
            return {
              onClick: () => onClickRow(record), // click row
            }
          }}
          style={{ marginTop: 32 }}
          dataSource={dataSource}
          columns={columns}
          onChange={onChangeTable}
          pagination={pagination}
          showSorterTooltip={false}
        />
      )
    }
  }

  const onClickDeleteHolodayDetail = (idHolidayDetail) => {
    if (selectedRowKeys.length > 0) {
      setVisibleDelete(true)
      let AllIDHoliday = idHolidayDetail.join(',')
      const dataArray = {
        idHoliday: parent_ID,
        idHolidayDetail: AllIDHoliday,
      }

      setDataDeleteHoliday(dataArray)
    }
  }

  const content = () => {
    // console.log(level)
    if (level == 4) {
      return (
        <Row justify="space-between" align="middle">
          <Col>
            <h2>{word['Holiday_Detail']}</h2>
          </Col>
          <Col>
            {/* <a
              // href="https://cpfit-nonprod.s3-ap-southeast-1.amazonaws.com/iproject_staging/9/holiday_example.xlsx"
              href={'/assets/docs/holiday_example.xlsx'}
            >
              <Button
                id="templeteholiday"
                icon={<DownloadOutlined className="Icon-color" />}
                className="btn_Secondary2"
              >
                {word['Templete']}
              </Button>
            </a> */}

            <Button
              hidden={permissionPage.delete ? false : true}
              type="primary"
              onClick={() => onClickDeleteHolodayDetail(selectedRowKeys)}
              className="btn_Secondary2"
              style={{ marginLeft: 8, width: 150 }}
            >
              <DeleteOutlined className="Icon-color" />
              {word['Delete']} {selectedRowKeys.length} {word['List']}
            </Button>
            {/* <Button
              hidden={permissionPage.create ? false : true}
              type="primary"
              className="btn_Secondary2"
              style={{ marginLeft: 8 }}
              onClick={() => setVisibleModal(true)}
            >
              <PlusOutlined className="Icon-color" /> {word['Import']}
            </Button> */}

            {/* <a href={path}>
              <Button
                type="primary"
                className="btn_Secondary2"
                style={{ marginLeft: 8 }}
                disabled={dataHolidayDetail.length == 0 ? true : false}
              >
                <PlusOutlined className="Icon-color" /> {word['Export']}
              </Button>
            </a> */}

            <Button
              type="primary"
              hidden={permissionPage.create ? false : true}
              onClick={() => onClickModalAddEditHolidayDetail('add')}
              className="BTN_Next"
              style={{ marginLeft: 8 }}
            >
              <PlusOutlined className="Icon-color" /> {word['Add_Detail']}
            </Button>
            <Button
              type="primary"
              style={{ marginLeft: 8 }}
              className="btn_Secondary2"
              onClick={() => window.location.reload()}
            >
              <RedoOutlined className="Icon-color" />
              {word['Reset']}
            </Button>
          </Col>

          {checkShowTable()}
        </Row>
      )
    } else {
      if (dataCompany.length > 0) {
        let wordd = 'Holiday'
        let wordstete = ''

        if (level == 1) {
          wordstete = 'Company'
        } else if (level == 2) {
          wordstete = 'Operation'
        } else {
          wordstete = 'Project type'
        }

        return (
          <div>
            <div className="layout-button-add-normal-state">
              <TextTitleBold>
                {wordd} {word['in']} {wordstete}
              </TextTitleBold>
              <div>
                {level === 1 && (
                  <a
                    // href="https://cpfit-nonprod.s3-ap-southeast-1.amazonaws.com/iproject_staging/9/holiday_example.xlsx"
                    href={'/assets/docs/holiday_template.xlsx'}
                  >
                    <Button
                      id="templeteholiday"
                      icon={<DownloadOutlined className="Icon-color" />}
                      className="btn_Secondary2"
                    >
                      {word['Templete']}
                    </Button>
                  </a>
                )}
                {level === 1 && (
                  <Button
                    hidden={permissionPage.create ? false : true}
                    type="primary"
                    className="btn_Secondary2"
                    style={{ marginLeft: 8 }}
                    onClick={() => setVisibleModal(true)}
                  >
                    <PlusOutlined className="Icon-color" /> {word['Import']}
                  </Button>
                )}
                {level === 1 && (
                  // <a href={path}>
                  <Button
                    type="primary"
                    className="btn_Secondary2"
                    style={{ marginLeft: 8 }}
                    onClick={() => setVisibleExportmodal(true)}
                  // disabled={dataHolidayDetail.length == 0 ? true : false}
                  >
                    <PlusOutlined className="Icon-color" /> {word['Export']}
                  </Button>
                  // </a>
                )}
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Button
                    hidden={permissionPage.create ? false : true}
                    onClick={() => eventAdd(wordd, level_ID)}
                    icon={<PlusOutlined className="Icon-color" />}
                    className="BTN_Next"
                    style={{ marginLeft: 8 }}
                  >
                    {word['Add']} {wordd}
                  </Button>
                  <Button
                    type="primary"
                    style={{ marginLeft: 8 }}
                    className="btn_Secondary2"
                    onClick={() => window.location.reload()}
                  >
                    <RedoOutlined className="Icon-color" />
                    {word['Reset']}
                  </Button>
                </div>
              </div>
            </div>
            {checkShowTable(level)}
          </div>
        )
      } else {
        let wordd = 'Holiday'

        return (
          <EmptyContainer className="initialstate-container">
            <img src={iconEmpty} />
            <h2> {word['Please_add_Holiday_in_your_project_optional']}</h2>
            <Button
              hidden={permissionPage.create ? false : true}
              onClick={() => eventAdd(wordd, level_ID)}
              icon={<PlusOutlined className="Icon-color" />}
              className="btn_Secondary2"
            >
              {word['Add']} {wordd}
            </Button>
          </EmptyContainer>
        )
      }
    }
  }

  const drawer = () => {
    if (dataAddEditHoliday) {
      return (
        <DrawerHoliday
          visible={visible}
          setVisible={setVisible}
          dataAddEditHoliday={dataAddEditHoliday}
          setCheckChangeTable={setCheckChangeTable}
          checkChangeTable={checkChangeTable}
          getResultTreeCompany={getResultTreeCompany}
          permissionPage={permissionPage}
        />
      )
    }
  }

  return (
    <CompanyContainer>
      <div className="layoutmanagement-git-master">
        <div className="layout-left" style={{ marginBottom: 32 }}>
          <div style={{ marginTop: 16, marginBottom: 16, marginLeft: 16, marginRight: 16 }}>
            <FilterSearchTree
              dataItems={resultscompany}
              selectedItems={filteredCompanies}
              setSelectedItems={setFilteredCompanies}
              placeholderText="Select Company"
              itemTypeName="Business"
              treeId="company"
              customTreeData={(item) => {
                const name = item.name_en || item.name_th || ''
                const title =
                  item.title ||
                  [item.code, name].filter((part) => part && part !== '-').join(' ') ||
                  String(item.id)
                return {
                  title,
                  value: item.id,
                  key: String(item.id),
                }
              }}
              excludeAllID={true}
            />
          </div>
          <Tree
            treeCompany={filteredTreeCompany}
            openDefaultTree={openDefaultTree}
            setLevel_ID={setLevel_ID}
            setLevel={setLevel}
            eventAdd={eventAdd}
            setCompanyID={setCompanyID}
            setCheckChangeTable={setCheckChangeTable}
            checkChangeTable={checkChangeTable}
            setParent_ID={setParent_ID}
            setDataExpanse={setDataExpanse}
            openDefaultTree3={openDefaultTree3}
            setDataSelected={setDataSelected}
            setCompany_id={setCompany_id}
            setOperation_id={setOperation_id}
            setSubOperation_id={setSubOperation_id}
          />
        </div>
        <div className="layout-right">{content()}</div>
        {drawer(dataAddEditHoliday)}
      </div>

      <AddEditModalHoliday
        visible={visibleModalAddEditHoliday}
        setvisible={setVisibleModalAddEditHoliday}
        dataAddEdit={dataModalAddEditHoliday}
        infoUser={infoUser}
        today={today}
        setCheckChangeTable={setCheckChangeTable}
        checkChangeTable={checkChangeTable}
        company_id={company_id}
        operation_id={operation_id}
        suboperation_id={suboperation_id}
        permissionPage={permissionPage}
      />

      <DeleteHoliday
        visibleDelete={visibleDelete}
        setVisibleDelete={setVisibleDelete}
        data={dataDeleteHoliday}
        setCheckChangeTable={setCheckChangeTable}
        state="HolidayDetail"
      />
      <Importfile
        state="Holiday"
        visible={visibleModal}
        setVisible={setVisibleModal}
        parent_ID={parent_ID}
        dataTree={treeCompany}
        getResultDataHolidayDetail={getResultDataHolidayDetail}
        fetchListHolidayINcompany={fetchListHolidayINcompany}
      />

      <ExportModalHoliday
        visible={visibleexportmodal}
        setVisible={setVisibleExportmodal}
        dataTree={treeCompany}
        parent_ID={parent_ID}
        token={token}
      />
    </CompanyContainer>
  )
}
export default Company
